import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  FormGroup,
  Button,
  Alert,
  InputGroup,
  InputGroupAddon,
  Spinner,
  UncontrolledAlert,
} from "reactstrap";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvFeedback,
} from "availity-reactstrap-validation";
import { User, Mail } from "react-feather";
import { isMobile } from "react-device-detect";
import { withTranslation } from "react-i18next";
import Cookies from "js-cookie";

const axios = require("axios").default;

class DataAccessDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      mode: 0,
    };
  }

  componentDidMount() {
    // Set a timer to open dialog after 1 second
    this.timer = setTimeout(() => {
      this.setState({ isOpen: true });
    }, 1000);
  }

  componentWillUnmount() {
    // Clear timer if component unmounts
    clearTimeout(this.timer);
  }

  componentDidUpdate(prevProps) {
    // Update state when props change
    if (prevProps.isOpen !== this.props.isOpen) {
      this.setState({ isOpen: this.props.isOpen });
    }
  }

  openDialog = () => {
    this.setState({ isOpen: true });
    if (this.props.onOpen) {
      this.props.onOpen();
    }
  };

  closeDialog = () => {
    if (this.state.mode != 0 && this.state.mode != 3) {
      this.setState({ mode: 0 });
    } else {
      this.setState({ isOpen: false });
      if (this.props.onClose) {
        this.props.onClose();
      }
    }
  };

  handleSendMessage = (event, { firstName, lastName, email, isPro }) => {
    //alert(`${firstName} ${lastName} ${email} ${isPro}`);
    const currentLanguage = this.props.i18n.language;
    
        // alert(`${firstName} ${lastName} ${email} ${currentLanguage} ${isPro}`);
    
        const body = {
          type: this.state.mode == 1 ? "contact_us" : "delete_contact_us",
          status: "open",
          firstName: firstName,
          lastName: lastName,
          email: email,
          language: currentLanguage,
          pro: isPro,
        };
        const headers = { "Content-Type": "application/json" };
        const url = "/api/v0-1/data-request";
    
        this.setState({showDialog: false, firstName: firstName, lastName: lastName, email: email });
    
        const instance = axios.create({
          baseURL: process.env.REACT_APP_API_BASE_URL,
          timeout: 10000,
          headers: headers,
        });
        console.log(process.env.REACT_APP_API_BASE_URL);
        console.log(process.env.REACT_APP_API_BASE_URL + url);
        instance
          .post(url, body)
          .then((response) => {
            console.log(response);
            return response;
          })
          .then((json) => {
            //alert("You message has been sent!");
            //Cookies.set("keepinform", true);
            localStorage.setItem('keepinform', 'true');  // string
            this.setState({ mode: 3 });
          })
          .catch((error) => {
            alert(error.toString());
          });
  };

  render() {
    const { isOpen } = this.state;
    const { t } = this.props;

    const labels = {
      0: t("Manage your data"),
      1: t("Update your data"),
      2: t("Delete your data"),
      3: t("Almost there!"),
    };

    return (
      <div
        className="dialog-overlay"
        style={{
          opacity: isOpen ? 1 : 0,
          transition: "opacity 1.0s ease-in-out",
        }}
      >
        <div className="dialog-content">
          <div className="dialog-header">
            <p className="item-title-large">{labels[this.state.mode]}</p>
            <button
              onClick={this.closeDialog}
              className="dialog-close-button"
              style={{ marginTop: "-15px" }}
            >
              &times;
            </button>
          </div>
          <div className="dialog-body">
            {this.state.mode == 0 ? (
              <div>
                <p className="item-description-large mt-3">
                  {t(
                    "We will consider and act upon any request in accordance with applicable data protection laws."
                  )}
                </p>

                <p className="item-description-large mt-3">
                  {t("• To modify your information, please click ")}
                  <a
                    href="#"
                    style={{ color: "#337DFF", textDecoration: "underline" }}
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ mode: 1 });
                    }}
                  >
                    here.
                  </a>
                </p>
                <p className="item-description-large mt-3">
                  {t("• To delete your information, please click ")}
                  <a
                    href="#"
                    style={{ color: "#337DFF", textDecoration: "underline" }}
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ mode: 2 });
                    }}
                  >
                    here.
                  </a>
                </p>
                <p className="item-description-large mt-3">
                  {t("• To find out more, see our ")}
                  <a
                    href={`${process.env.PUBLIC_URL}/privacy`}
                    style={{ color: "#337DFF", textDecoration: "underline" }}
                  >
                    {t("Privacy Policy")}
                  </a>
                  .
                </p>
              </div>
            ) : this.state.mode == 1 ? (
              <AvForm
                onValidSubmit={this.handleSendMessage}
                onInvalidSubmit={(event, errors, values) => {
                  console.log("Invalid fields:", errors); // Debug invalid inputs
                }}
                className="authentication-form mt-30"
              >
                <p className="item-description-large mt-3">
                  {t(
                    "Here you can adjust your data. Those will replace the previous data you saved. You will receive a verification email to confirm the update."
                  )}
                </p>
                <br />
                <Row>
                  <Col>
                    <AvGroup>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <span className="input-group-text">
                            <User className="icon-dual" />
                          </span>
                        </InputGroupAddon>
                        <AvInput
                          type="text"
                          name="firstName"
                          value={this.state.firstName}
                          placeholder={t("First Name")}
                          onChange={(e) =>
                            this.setState({ firstName: e.target.value })
                          }
                          required
                          validate={{
                            required: {
                              value: true,
                              errorMessage: t("This field is invalid"),
                            },
                          }}
                          className={
                            this.state.showAllErrors ? "is-invalid" : ""
                          }
                        />
                        <AvFeedback>{t("This field is invalid")}</AvFeedback>
                      </InputGroup>
                    </AvGroup>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <AvGroup>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <span className="input-group-text">
                            <User className="icon-dual" />
                          </span>
                        </InputGroupAddon>
                        <AvInput
                          type="text"
                          name="lastName"
                          value={this.state.lastName}
                          placeholder={t("Last Name")}
                          onChange={(e) =>
                            this.setState({ lastName: e.target.value })
                          }
                          required
                          validate={{
                            required: {
                              value: true,
                              errorMessage: t("This field is invalid"),
                            },
                          }}
                          className={
                            this.state.showAllErrors ? "is-invalid" : ""
                          }
                        />
                        <AvFeedback>{t("This field is invalid")}</AvFeedback>
                      </InputGroup>
                    </AvGroup>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <AvGroup className="mb-3">
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <span className="input-group-text">
                            <Mail className="icon-dual" />
                          </span>
                        </InputGroupAddon>
                        <AvInput
                          type="email"
                          name="email"
                          value={this.state.email}
                          placeholder={t("Email address")}
                          onChange={(e) =>
                            this.setState({ email: e.target.value })
                          }
                          required
                          validate={{
                            required: {
                              value: true,
                              errorMessage: t("This field is invalid"),
                            },
                          }}
                          className={
                            this.state.showAllErrors ? "is-invalid" : ""
                          }
                        />
                        <AvFeedback>{t("This field is invalid")}</AvFeedback>
                      </InputGroup>
                    </AvGroup>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <p class="item-description-large mt-4">{t("Optional info:")}</p>
                    <label class="checkbox-wrapper">
                      <p class="item-description-large">{t(
                        "I am an eco-certified professional, and would also like to know more about how to register my business on the platform."
                      )}
                      </p>
                      <AvInput
                        type="checkbox"
                        name="isPro"
                        value={this.state.isPro}
                        onChange={(e) =>
                          this.setState({ isPro: e.target.value })
                        }
                      />
                      <span class="checkbox-custom"></span>
                    </label>
                  </Col>
                </Row>
                <br />
                <FormGroup className="form-group mb-0 text-center">
                  <div className="row align-items-center justify-content-center">
                    <Button
                      className="btn-default custom"
                      type="submit"
                      value="submit"
                      name="submit"
                      id="mc-embedded-subscribe"
                    >
                      {t("Send")}
                    </Button>
                  </div>
                </FormGroup>
              </AvForm>
            ) : this.state.mode == 2 ? (
              <AvForm
                onValidSubmit={this.handleSendMessage}
                onInvalidSubmit={(event, errors, values) => {
                  console.log("Invalid fields:", errors); // Debug invalid inputs
                }}
                className="authentication-form mt-30"
              >
                <p className="item-description-large mt-3">
                  {t(
                    "By removing your information, you will no longer receive updates about our progress, notifications when the app is ready to download, or other important information along the way."
                  )}
                </p>
                
                <Row className="mt-3 mb-3">
                  <Col>
                    <AvGroup className="mb-3">
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <span className="input-group-text">
                            <Mail className="icon-dual" />
                          </span>
                        </InputGroupAddon>
                        <AvInput
                          type="email"
                          name="email"
                          value={this.state.email}
                          placeholder={t("Email address")}
                          onChange={(e) =>
                            this.setState({ email: e.target.value })
                          }
                          required
                          validate={{
                            required: {
                              value: true,
                              errorMessage: t("This field is invalid"),
                            },
                          }}
                          className={
                            this.state.showAllErrors ? "is-invalid" : ""
                          }
                        />
                        <AvFeedback>{t("This field is invalid")}</AvFeedback>
                      </InputGroup>
                    </AvGroup>
                  </Col>
                </Row>

                <FormGroup className="form-group mb-0 text-center">
                  <div className="row align-items-center justify-content-center">
                    <Button
                      className="btn-default custom"
                      type="submit"
                      value="submit"
                      name="submit"
                      id="mc-embedded-subscribe"
                    >
                      {t("Send")}
                    </Button>
                  </div>
                </FormGroup>
              </AvForm>
            ) : (
              <div className="item-description-large mt-3">
                <p className="item-description-large mt-3">
                  {t("A verification email has been sent to")}
                </p>
                <p className="item-description-large mt-3 font-bold">
                  {this.state.email}
                </p>
                <p className="item-description-large mt-3">
                  {t(
                    "Check your inbox to verify your email address. If you can’t see the email, it may be in your spam!"
                  )}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(DataAccessDialog);
